<template>
    <ResourcePage v-if="successStory" :theme="theme">
        <template #header>
            <ResourcePageHero :document="successStory" />
        </template>
        <template #main>
            <SliceZone :components="components" :slices="successStory?.data?.slices ?? []" :context="{parentDocument: successStory}" />
        </template>
        <template #aside>
            <div class="article-social-sharing">
                <SocialSharing />
            </div>
        </template>
    </ResourcePage>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import type {SuccessStoryDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import ResourcePage from '~/components/ResourcePage.vue';
    import ResourcePageHero from '~/components/ResourcePageHero.vue';
    import SocialSharing from '~/components/SocialSharing.vue';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {useResolvePrismicDocument} from '~/composables/content/useResolvePrismicDocument';
    import {useDocumentMetadata} from '~/composables/useDocumentMetadata';
    import {components} from '~/slices/components';

    const {
        params: {uid},
    } = useRoute('resources-success-story-uid');
    const {data, error} = await useAsyncData('success-story', () => usePrismicDocument<SuccessStoryDocument>('successStory', uid as string));
    const successStory = useResolvePrismicDocument(data, error);

    const theme = computed(() => {
        if (successStory.value?.data.theme) {
            return successStory.value?.data.theme;
        }
        if (successStory.value?.data.useAlternativeHeroShapes) {
            return 'corporate';
        }
        return 'default';
    });

    if (successStory.value) {
        useDocumentMetadata(successStory.value);
    }

    useWebsitePageView('resources-center', 'success-stories');
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .article-social-sharing {
        background-color: var(--joy-color-background-default);
        border: solid 1px var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);
    }
</style>
